import {
	GANTT_BORDER_COLOR,
	GANTT_DELAY_BORDER_COLOR,
	GANTT_HOVER_BG,
} from "@/shared/colors";

type UseBarStylesProps = {
	id: string;
	x: number;
	y: number;
	width: number;
	height: number;
	isHighlighted: boolean;
	useGradient: boolean;
	backgroundColor: string;
};

const HOVER_PADDING = 2;

export const useBarStyles = ({
	id,
	x,
	y,
	width,
	height,
	isHighlighted,
	useGradient,
	backgroundColor,
}: UseBarStylesProps) => {
	// Generate unique IDs for SVG definitions
	const sanitizedId = id.replace(/[^a-zA-Z0-9]/g, "");
	const gradientId = `grad-${sanitizedId}`;
	const filterId = `shadow-${sanitizedId}`;

	// Hover effect: slight scale simulation
	const padding = isHighlighted ? HOVER_PADDING : 0;
	const dimensions = {
		x: x - padding,
		y: y - padding,
		width: width + padding * 2,
		height: height + padding * 2,
	};

	// Colors
	// For tasks (useGradient=true): use gradient fill
	// For taskLines (useGradient=false): keep original backgroundColor (no color change on hover)
	const fillColor = useGradient ? `url(#${gradientId})` : backgroundColor;

	const strokeColor = useGradient
		? GANTT_BORDER_COLOR
		: GANTT_DELAY_BORDER_COLOR;

	// Increase stroke width on hover for both tasks and taskLines
	const strokeWidth = isHighlighted ? 2 : 1;

	return {
		gradientId,
		filterId,
		dimensions,
		fillColor,
		strokeColor,
		strokeWidth,
	};
};
